<template>
  <el-row>
    <el-descriptions size="small" direction="vertical" :column="3" border>
      <el-descriptions-item
        :label="$l('form_label_originalFileName') || '原始文件名称'"
        :contentStyle="{ width: '380px' }"
      >
        {{ formData.originalFileName }}
      </el-descriptions-item>

      <el-descriptions-item :label="$l('form_label_createBy') || '上传人'">
        {{ formData.createByName }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_createByTime') || '上传时间'"
      >
        {{ formData.createByTime }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_processedFileURL') || '处理后文件'"
      >
        <el-link
          class="mr-2"
          v-if="downloadUrl(true)"
          :href="downloadUrl(true)"
          target="_blank"
          type="primary"
          :underline="false"
        >
          {{ $l('btn_preview') || '点击预览' }}
        </el-link>

        <el-link
          v-if="downloadUrl()"
          :href="downloadUrl()"
          target="_blank"
          type="primary"
          :underline="false"
        >
          {{ $l('btn_download') || '点击下载' }}
        </el-link>
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_processFlag') || '文件处理状态'"
      >
        <el-tag
          v-if="formData.v_processFlag"
          size="mini"
          :type="
            formData.processFlag === 'Y'
              ? 'success'
              : formData.processFlag === 'F'
              ? 'warning'
              : formData.processFlag === 'K'
              ? 'info'
              : formData.processFlag === 'D'
              ? 'danger'
              : formData.processFlag === 'P'
              ? 'P'
              : ''
          "
        >
          {{ formData.v_processFlag }}
        </el-tag>
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_processDatetime') || '文件处理时间'"
      >
        {{ formData.processDatetime }}
      </el-descriptions-item>
      <el-descriptions-item
        v-if="formData.processMessage"
        :label="$l('form_label_processMessage') || '文件处理结果'"
      >
        {{ formData.processMessage }}
      </el-descriptions-item>
    </el-descriptions>
  </el-row>
</template>

<script>
export default {
  props: { toolUploadFileCode: { type: String, default: '' } },
  data() {
    return { formData: {} }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.toolUploadFileCode) return
      const res = await this.$api
        .ecomToolUploadFilesDetailApi({
          toolUploadFileCode: this.toolUploadFileCode,
        })
        .catch(() => null)
      if (!res) return
      this.formData = res.body || {}
    },
    downloadUrl(preview = false) {
      const { toolUploadFileCode, processFlag } = this.formData
      if (processFlag !== 'Y') return

      return this.$joinURL(
        `/api/ecom/tool/upload/files/download/${toolUploadFileCode}?preview=${
          preview ? 1 : 0
        }`,
        {
          joinOrigin: true,
          joinBasePath: false,
        }
      )
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-tag--P {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
